<script>
    import CartNavigationContainer from './CartNavigationContainer'
    import CartElement from './CartElement'
    import FiscalFileForm from './FiscalFileForm'
    import ConfirmForm from './ConfirmForm'
    import StripeCardForm from './StripeCardForm'
    import CartCouponForm from './CartCouponForm'
    import {Form} from '../../helpers/Form/Form'


    export default {
        props: ['items', 'totalPrice', 'userprop', 'loggedinprop'],
        components: {
            CartNavigationContainer,
            CartElement,
            FiscalFileForm,
            ConfirmForm,
            StripeCardForm,
            CartCouponForm
        },
        data() {
            const form = new Form({
                id: null,
                payment: 'card',
                has_already_bought: false,
                email: '',
                phone: '',
                phonePrefix: '+39',
                password: null,
                fiscal_file: {
                    address: null,
                    house_number: null,
                    is_for_this_user: 1,
                    day: null,
                    month: null,
                    year: null,
                    email: '',
                    phonePrefix: '+39',
                    phone: '',
                    first_name: '',
                    last_name: '',
                    province: '',
                    municipality: '',
                    zip: '',
                    fiscal_code: '',
                    state: 'ITALIA',
                    nationality: 'italian',
                    accept_promotions: false
                },
                save_card: false,
                name: '',
                stripe_id: null,
                stripeToken: null,
                i_payment: null,
                p_intent: null,
                pay_method: null,
                card_brand: null,
                instalments: null,
                card_last_four: null,
                exploitable_code: null,
                exploitable_used: false,
                discount: 0,
                total: this.totalPrice,
                is_gift: false,
                gift_form_is_valid: false,
                gift_recipient: {
                    email: "",
                    name: "",
                    sender_name: "",
                    message: "Spero che questo regalo ti piaccia. Scopri la tua passione sportiva!"
                }
            });

            if (this.loggedinprop) {
                form.setAllData(this.userprop)
            }

            return {
                form,
                stripe: {
                    form: null,
                    cardElements: null,
                },
                discount: 0,
                cartElements: this.items,
                exploitable_message: '',
                exploitable_invalid_response: false,
                exploitable: {
                    fixed_discount: null,
                    percent_discount: null,
                },
                exploitable_used: false,
                tab: 'cart',
                subTab: null,
                loggedIn: this.loggedinprop,
                tabs: ['cart', 'billing', 'payment', 'confirm'],
                showStickyButtons: window.isMobile()
            }
        },
        computed: {
            currentIndexTab() {
                return _.findIndex(this.tabs, i => i == this.tab)
            },
            canProceed() {
                if (this.form.is_gift) {
                    return this.cartElements.length > 0 && this.giftFormIsComplete()
                }
                return this.cartElements.length > 0
            },
            showNavigation() {
                return _.isEmpty(this.subTab)
            },
            giftCards() {
                return this.cartElements.filter(i => i.buyable_type == 'App\\CustomGiftCard')
            },
            defaultItems() {
                return this.cartElements.filter(i => {
                    return !['App\\CustomGiftCard', 'App\\SummerCampProduct', 'App\\CompanyFee'].includes(
                        i.buyable_type
                    )
                })
            },
            hasAlreadySaveACard() {
                return !_.isEmpty(this.form.card_brand) && !_.isEmpty(this.form.card_last_four) && !_.isEmpty(this.form.stripe_id)
            },
            summerCampProductItems() {
                return this.cartElements.filter(i => {
                    return 'App\\SummerCampProduct' == i.buyable_type
                })                
            },
            companyFeeProductItems() {
                return this.cartElements.filter(i => {
                    return 'App\\CompanyFee' == i.buyable_type
                })                
            }            
        },
        watch: {
            cartElements(val) {
                if (_.isEmpty(val)) {
                    this.resetNavigationTabs()
                    this.resetFormData()
                    this.setRouteTabs()
                }
            }
        },
        mounted() {
            this.setRouteTabs()
            
            this.$bus.$on('update-gift-status', (value) => {
                this.form.is_gift = value
                if (! this.form.is_gift) {
                    this.$set(this.form, 'gift_recipient', {
                        sender_name: "",
                        name: "",
                        email: "",
                        message: "Spero che questo regalo ti piaccia. Scopri la tua passione sportiva!"
                    })
                }
            })

            this.$bus.$on('update-recipient-data', (recipient) => {
                this.form.gift_recipient = recipient;
            })

            this.$bus.$on('update-total', this.updateTotal)

            this.$bus.$on('remove_all_cart_elements_except_gift', (gift) => {
                axios({
                    method: 'delete',
                    url: '/carts/allExcept/' + gift.buyable_id
                }).then((response) => {
                    this.cartElements = this.cartElements.filter(i => i.buyable_id === gift.buyable_id)
                    this.calculateTotalCart()
                }).catch((error) => {
                    this.$emit('init-error', 'Delete failed')
                })
            })

            $("#info-fee").modal({
                show: false,
                backdrop: 'static',
                keyboard: false
            })

            window.addEventListener('resize', (e) => {
                this.showStickyButtons = window.isMobile
            })

            this.initAnalytics()
        },
        methods: {
            initAnalytics() {
                let promotions = this.defaultItems.filter(i => i.buyable_type == 'App\\CoursePromotion')
                if (promotions.length > 0) {
                    this.$bus.$emit('update-course-promotion-analytics')
                }
            },
            giftFormIsComplete() {
                return !_.isEmpty(this.form.gift_recipient.sender_name) &&
                    !_.isEmpty(this.form.gift_recipient.name) &&
                    !_.isEmpty(this.form.gift_recipient.email)
            },
            setRouteTabs() {
                if (this.form.has_already_bought) {
                    let idx = _.findIndex(this.tabs, r => r == 'billing')
                    this.tabs.splice(idx, 1)
                }

                // if (this.hasAlreadySaveACard) {
                //     let idx = _.findIndex(this.tabs, r => r == 'payment')
                //     this.tabs.splice(idx, 1)
                // }
            },
            resetNavigationTabs() {
                this.tab = 'cart'
                this.$bus.$emit('reset-tabs')
            },
            resetFormData() {
                this.$bus.$emit('reset-form-data')
            },
            updateItem({item, active}) {
                let idx = _.findIndex(this.cartElements, i => i.id == item.id)
                if (idx == 0)
                    idx = _.findIndex(this.cartElements, i => i.session_id == item.session_id)

                this.$set(this.cartElements[idx], 'with_membership_fee', active)

                this.calculateTotalCart();
            },
            deleteItem({item}) {
                let idx = _.findIndex(this.cartElements, el => el.id == item.id)
                if (idx >= 0) {
                    this.cartElements.splice(idx, 1);
                }

                this.calculateTotalCart();
            },
            updateItems({items}) {

                this.cartElements = items
                this.calculateTotalCart();
            },
            calculateTotalCart() {
                let total = 0;
                this.cartElements.forEach(cartElement => {
                    if (cartElement.buyable_type == 'App\\SummerCampProduct') {
                        total += parseFloat(cartElement.buyable.price_final_with_discount);
                        if (cartElement.with_membership_fee && cartElement.buyable.membership_fee) {
                            total += parseFloat(cartElement.buyable.membership_fee * cartElement.buyable.n_partecipants)
                        }                        
                    } else {
                        total += parseFloat(cartElement.buyable.price);
                        if (this.isPromotion(cartElement.buyable_type)) {
                            if (cartElement.with_membership_fee && cartElement.buyable.course.active_promotion_fee && cartElement.buyable.course.promo_membership_fee) {
                                total += parseFloat(cartElement.buyable.course.promo_membership_fee * cartElement.buyable.people)
                            }
                        } else if (cartElement.with_membership_fee) {
                            if (cartElement.buyable.fee) {
                                total += +parseFloat(cartElement.buyable.fee.price)
                            } else if (cartElement.buyable.membership_fee) {
                                total += +parseFloat(cartElement.buyable.course.membership_fee)
                            }
                        }
                    }
                });

                this.$set(this.form, 'total', total)

                if (this.form.total) {
                    if (this.form.exploitable_used)
                        if(!this.form.is_gift)
                            this.$bus.$emit('verify-coupon', {});
                    // this.$bus.$emit('apply-discounts', {});
                    else {
                        let discount = total - this.form.discount
                        this.$set(this.form, 'total', discount)
                    }

                }
            },
            isPromotion(buyable_type) {
                return buyable_type === "App\\CoursePromotion"
            },
            getCouponPlaceholder(notUsedMsg, alreadyUsedMsg) {
                return this.exploitable_used ? alreadyUsedMsg : notUsedMsg
            },
            onNextTab() {
                if (this.showStickyButtons) {
                    if (this.tab == 'billing') {
                        this.$bus.$emit('submit-billing')
                    } else if (this.tab == 'payment') {
                        this.$bus.$emit('submit-payment')
                    } else if (this.tab == 'confirm') {
                        this.$bus.$emit('submit-confirm')
                    } else {
                        this.onSubmit()
                    }
                } else {
                    this.onSubmit()
                }
            },
            onSubmit() {
                this.form
                    .submit('post', route('carts.validate_gift'))
                    .then(response => {
                        let currentIdx = _.findIndex(this.tabs, r => r == this.tab)
                        this.$set(this, 'tab', this.tabs[currentIdx + 1])

                        this.$bus.$emit('validation-fails', {form: null})

                        this.scrollOnTop()
                    })
                    .catch(error => {
                        window.alerts.error('Attenzione completa i campi segnati in rosso prima di proseguire')

                        this.$bus.$emit('validation-fails', {form: this.form})
                    })
            },
            onBack() {
                if (this.currentIndexTab > 0) {
                    this.$set(this, 'tab', this.tabs[this.currentIndexTab - 1])

                    this.scrollOnTop()
                }
            },
            switchTab(tab) {
                this.$set(this, 'tab', tab)

                this.scrollOnTop()
            },
            isSelected(tab) {
                return this.tab == tab
            },
            updateFormData({data}) {
                this.form.setAllData(data)
            },
            updateStripe(data) {
                this.$set(this, 'stripe', data)
            },
            switchSubTab(subTab) {
                this.$set(this, 'subTab', subTab)
            },
            resetSubTab() {
                this.subTab = null
            },
            updateTotal({total, exploitable_code, exploitable_used, discount}) {
                this.$set(this.form, 'total', total)
                this.$set(this.form, 'exploitable_code', exploitable_code)
                this.$set(this.form, 'exploitable_used', exploitable_used)
                this.$set(this.form, 'discount', discount)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartFormContainer.vue